<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content slip_out_animation" style="height: 45%">
          <div class="type-title">
            <div>库存总量：486吨</div>
          </div>
          <div id="left-echarts-1" class="left-echarts-1"></div>
        </div>

        <div class="left-content slip_out_animation" style="height: 55%">
          <div class="type-title">
            <div>产出物占比</div>
          </div>
          <div id="left-echarts-2" class="left-echarts-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsRightBottom();
        this.createdCarEchartsLeftBottom();
      });
    }, 200);
  },
  methods: {
    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        grid: {
          top: 15,
          left: 0,
          right: "8%",
          bottom: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          show: false,

          data: ["Growth", "销售重量（吨）", "销售金额（元）"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        xAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            data: ["废钢","杂铝","铝水箱","电机","杂铜"],
            axisLabel: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "数据1",
            type: "bar",
            data: [16, 96, 50, 12, 15, 31],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 饼图
    createdCarEchartsLeftBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");
      var myChart = echarts.init(leftEchartsTOP);
      //   { value: 1048, name: "轿车" },
      //           { value: 735, name: "公交车" },
      //           { value: 580, name: "吊车" },
      //           { value: 484, name: "叉车" },
      //           { value: 300, name: "货车" },
      var option;
      option = {
        grid: {
          bottom: "20px",
          containLabel: true,
        },
        title: {
          subtext: "单位：吨",
          left: "right",
          subtextStyle: {
            color: "#FFF",
            fontSize: "18",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + ":  " + params.percent + "%";
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          //   show: false,
          //   bottom: "bottom",
          bottom: "80",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["20%", "40%"],
            avoidLabelOverlap: false,
            data: [
              { value: 108, name: "废钢" },
              { value: 735, name: "杂铝" },
              { value: 580, name: "铝水箱" },
              { value: 484, name: "电机" },
              { value: 300, name: "杂铜" },
            ],
            label: {
              fontSize: 12,
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
              //   position: "center",
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
    <style scoped>
.main .left {
  width: 21.5vw;

  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
}

.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  height: 60%;
}
::v-deep .main .left .left-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-top-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 20vh;
}
.left-top-content-item {
  width: 50%;
  text-align: center;
  font-size: 20px;
}
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 100%;
}
</style>
    